import styled from 'styled-components';
import { ThemeEnum } from '../../handlers/ThemeHandler';

export const Image = styled.img<{ isLogoTile: boolean }>`
  min-width: auto;
  max-width: 100%;
  min-height: auto;
  max-height: 100%;
  cursor: ${({ isLogoTile }) => (isLogoTile ? 'pointer' : 'inherit')};

  &.tile-static-img-styles {
    ${({ isLogoTile }) =>
      isLogoTile
        ? 'max-width: 100%; max-height: 100%; width: auto; height: auto; margin: 10px'
        : 'max-height: 95%;'};
  }

  input {
    visibility: hidden;
  }
`;

export const DateTime = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: ${({ theme }) =>
    theme.theme === ThemeEnum.light ? '#626262' : 'white'};

  margin: 5px 0;

  .date {
    font-size: 32px;
  }

  .time {
    font-size: 20px;
  }

  @media (max-width: 950px) {
    .date {
      font-size: 20px;
    }

    .time {
      font-size: 12px;
    }
  }
  @media (max-width: 600px) {
    .date {
      font-size: 14px;
    }

    .time {
      font-size: 8px;
    }
  }
`;
